import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from './../../../core/service/base/data.service';
import { MessageService } from './../../../core/service/message.service';
import { ProgressBarService } from './../../../core/service/progress-bar.service';
import { Observable, catchError, map } from 'rxjs';
import { Company } from '../../../rent/model/company';
import { Property } from '../../../rent/model/property';
import { RentalObjectKeyHandover } from '../../model/rental-object-key';

@Injectable()
export class RentalObjectKeyHandoverService extends DataService<RentalObjectKeyHandover> {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) private _config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(_client, _config, messageService, RentalObjectKeyHandover, progressBar, 'rental-object-key-handover');
  }
}
